import { epicPersistenceWriteBeforeAction } from "./epic/epicPersistenceWriteBeforeAction";
export var epicPersistence = epicPersistenceWriteBeforeAction;



//////////////////
// WEBPACK FOOTER
// ./src/features/persistence/epicPersistence.ts
// module id = 2038
// module chunks = 3